export default function Gallery() {
  const images = [
    {
      url: 'https://www.britishtailors.com/wp-content/uploads/2016/06/img1.jpg',
      title: 'Custom Tailored Suits',
      category: 'Suits'
    },
    {
      url: 'https://www.britishtailors.com/wp-content/uploads/2016/06/img2.jpg',
      title: 'Premium Fabrics',
      category: 'Materials'
    },
    {
      url: 'https://www.britishtailors.com/wp-content/uploads/2016/06/img3.jpg',
      title: 'Expert Craftsmanship',
      category: 'Details'
    },
    {
      url: 'https://www.britishtailors.com/wp-content/uploads/2016/08/style_guide-e1471835477354.jpg',
      title: 'Style Consultation',
      category: 'Service'
    }
  ];

  return (
    <section id="gallery" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            Our <span className="text-[#C9A961]">Craftsmanship</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Explore examples of our <strong>exquisite custom tailoring</strong> and attention to detail
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {images.map((image, index) => (
            <div 
              key={index}
              className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300"
            >
              <div className="relative h-80 overflow-hidden">
                <img 
                  src={image.url}
                  alt={image.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
              
              <div className="absolute bottom-0 left-0 right-0 p-6 text-white transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                <div className="text-sm font-semibold text-[#C9A961] mb-1">{image.category}</div>
                <h3 className="text-lg font-bold">{image.title}</h3>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <a 
            href="#consultation" 
            className="inline-block bg-gray-900 text-white px-10 py-4 rounded-full text-lg font-semibold hover:bg-gray-800 transition-all duration-300 shadow-xl hover:shadow-2xl whitespace-nowrap"
          >
            Start Your Custom Project
          </a>
        </div>
      </div>
    </section>
  );
}